import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {take} from "rxjs";
import {BackOfficeConfig} from "../interfaces/back-office-config";
import {ConfigService} from "./config.service";

@Injectable({
  providedIn: 'root'
})
export class AssetsService {

  targetStorage: string = '';
  backofficeConfig: BackOfficeConfig = {} as BackOfficeConfig;

  constructor(private http: HttpClient, private configService: ConfigService) {
  }

  initializeAssets(): Promise<boolean> {
    this.backofficeConfig = this.configService.getBackOfficeConfig();
    this.targetStorage = this.backofficeConfig['FLEET_ASSETS_TARGET_ON_LOCAL_STORAGE'];
    switch (this.backofficeConfig['TRANSLATION_SOURCE']) {
      case 'LOCAL':
        return this.initializeLocalAssets()
      case 'BUCKET':
        return this.initializeBucketAssets()
      case 'BACKOFFICE':
        return this.initializeBackOfficeAssets()
      default:
        return new Promise<boolean>((resolve) => {
          resolve(false)
        });
    }
  }

  initializeLocalAssets(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.http.get(`http://localhost:3000/getAssets`).pipe(take(1)).subscribe((value) => {
        localStorage.setItem(this.targetStorage, JSON.stringify(value))
      });
      resolve(true);
    });
  }

  initializeBucketAssets(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.http.get(`/fakeoffice/asset_map/asset_map.json`).pipe(take(1)).subscribe((value) => {
        localStorage.setItem(this.targetStorage, JSON.stringify(value))
      });
      resolve(true);
    });
  }

  initializeBackOfficeAssets(): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      const culture = this.backofficeConfig.BACKOFFICE_CONFIG.CULTURE;
      const isProduction = process.env['BO_ENV'] === "backoffice-prod";
      const domain = isProduction ? 'settings.spacemdw.com' : 'settings.int.spacemdw.com';
      await this.http.get(`https://${domain}/?brand=xx&culture=en-XX&source=FLEET&widgetname=fleet-asset`).pipe(take(1)).subscribe((value: any) => {
        localStorage.setItem(this.targetStorage, JSON.stringify(value['features'][0]['attributes']))
      });
      resolve(true);
    });
  }

  getAsset(assetName: string): string {
    const assetList = localStorage.getItem(this.targetStorage);
    if (!assetList) return 'ERROR:Missing_asset_list';
    let parsedList = JSON.parse(assetList);
    if (parsedList['assetList']) parsedList = parsedList['assetList'];
    const getValueByKey = (obj: Record<string, any>, key: string): string =>
      obj.hasOwnProperty(key) ? obj[key] : 'ERROR:'+key+' Asset_not_found';
    return getValueByKey(parsedList, assetName);
  }
}
